
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/2014-09-19-queue-for-the-iphone-6",
      function () {
        return require("private-next-pages/posts/2014-09-19-queue-for-the-iphone-6.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/2014-09-19-queue-for-the-iphone-6"])
      });
    }
  